import { commonUtils } from '../../../common-assets/js/components/common_utils';
import { advanceSearchFieldHeaderCommon } from '../../../common-assets/js/components/advance_search_field_header_common';

export const advanceSearchFieldHeader = {
    isDesktopView: commonUtils.isSearchModalDesktopView(),
    elementsByName: [
        'carType[]',
        'vanType[]',
        'accessories[]',
        'lastInspectionMonth',
        'lastInspectionYear',
        'firstRegistrationMonth',
        'firstRegistrationYear',
        'powerFrom',
        'powerTo',
        'powerUnit',
        'make',
        'model',
        'regionTown',
        'maxDaysSinceModification',
        'kilometersFrom',
        'kilometersTo',
        'undriven',
        'parentDealerList',
    ],
    elementsByType: ['checkbox', 'radio', 'text', 'number'],
    excludedFieldsInDisplay: [
        'any',
        'consumptionPlace',
        'electricConsumptionPlace',
        'isPriced',
        'vatDeduct',
        'taxFree',
        'towWeightWithBrakes',
    ],
    showSelectedValueInFieldHeader(object, callFromEvent = false) {
        // Don't show selected value in section header, that will be shown in mobile view only
        if (this.isDesktopView) {
            return;
        }

        // Get element name and type
        let elementName = object.attr('name');
        let elementType = object.attr('type');

        // Set case type based on element name or element type
        let caseType;
        if (advanceSearchFieldHeader.elementsByName.includes(elementName)) {
            caseType = 'elementsByName';
        } else if (advanceSearchFieldHeader.elementsByType.includes(elementType)) {
            caseType = 'elementsByType';
        } else if (object.hasClass('rangeField')) {
            caseType = 'rangeField';
        }

        // Prepare field header value based on case type
        switch (caseType) {
            case 'elementsByName': {
                advanceSearchFieldHeader.prepareFieldHeaderValueByFieldName(elementName, object);
                break;
            }
            case 'elementsByType': {
                let unit = advanceSearchFieldHeader.getUnitValueForFreeFormatField(elementName);
                advanceSearchFieldHeaderCommon.prepareFieldHeaderValueByFieldType(object, unit);
                break;
            }
            case 'rangeField':
                {
                    let fromField = elementName.replace('To', 'From');
                    let toField = elementName.replace('From', 'To');
                    let unit = advanceSearchFieldHeader.getUnitValueForFreeFormatField(elementName);
                    let selectedFieldValue = advanceSearchFieldHeaderCommon.getValueForRangeField(
                        fromField,
                        toField,
                        false,
                        unit,
                        true
                    );

                    if (
                        selectedFieldValue &&
                        (advanceSearchFieldHeaderCommon.isSectionTitleEmpty(object) || callFromEvent)
                    ) {
                        advanceSearchFieldHeaderCommon.updateFieldHeader(object, selectedFieldValue);
                    }
                }
                break;
            default:
                break;
        }
    },
    prepareFieldHeaderValueByFieldName(fieldName, object) {
        let selectedFieldValue = '';

        // Prepare field header value based on field name
        switch (fieldName) {
            case 'carType[]':
            case 'vanType[]':
                selectedFieldValue = advanceSearchFieldHeader.showCarTypeVanTypeSelectedValueInHeader(object);
                break;
            case 'make':
            case 'model':
                {
                    let $selectedMakeModels = $('#advance_search #makeModelSelected option:selected');
                    selectedFieldValue =
                        $selectedMakeModels.length > 1
                            ? Translations.advanced_search.multiple
                            : $selectedMakeModels.text();
                }
                break;
            case 'kilometersFrom':
            case 'kilometersTo':
            case 'undriven':
                selectedFieldValue = advanceSearchFieldHeader.showKilometerSelectedValueInHeader();
                break;
            case 'lastInspectionMonth':
            case 'lastInspectionYear':
                selectedFieldValue = advanceSearchFieldHeaderCommon.getValueForRangeField(
                    'lastInspectionMonth',
                    'lastInspectionYear'
                );
                break;
            case 'firstRegistrationMonth':
            case 'firstRegistrationYear':
                selectedFieldValue = advanceSearchFieldHeaderCommon.getValueForRangeField(
                    'firstRegistrationMonth',
                    'firstRegistrationYear'
                );
                break;
            case 'powerFrom':
            case 'powerTo':
            case 'powerUnit':
                {
                    let powerUnit = $('#advance_search #powerUnit option:selected').text();
                    selectedFieldValue = advanceSearchFieldHeaderCommon.getValueForRangeField(
                        'powerFrom',
                        'powerTo',
                        false,
                        powerUnit
                    );
                }
                break;
            case 'accessories[]':
                selectedFieldValue = advanceSearchFieldHeader.showAccessoriesSelectedValueInHeader(object);
                break;
            case 'maxDaysSinceModification':
                selectedFieldValue =
                    advanceSearchFieldHeaderCommon.showAdModificationSinceSelectedValueInHeader(fieldName);
                break;
            case 'regionTown':
                selectedFieldValue = advanceSearchFieldHeaderCommon.showLocationSelectedValueInHeader();
                break;
            case 'parentDealerList':
                {
                    let $selectedDealerShip = $('#advance_search #parentDealerSelected option:selected');
                    selectedFieldValue =
                        $selectedDealerShip.length > 1
                            ? Translations.advanced_search.multiple
                            : $selectedDealerShip.text();
                }
                break;
            default:
                break;
        }

        advanceSearchFieldHeaderCommon.updateFieldHeader(object, selectedFieldValue);
    },
    getUnitValueForFreeFormatField(fieldName) {
        let unit = fieldName.indexOf('price') !== -1 ? '€' : '';
        unit = fieldName.toLowerCase().indexOf('towweight') !== -1 ? 'kg' : unit;
        unit =
            fieldName.toLowerCase() === 'chargingpowerfrom' || fieldName.toLowerCase() === 'chargingpowerto'
                ? 'kW'
                : unit;
        unit = fieldName.toLowerCase().indexOf('co2emission') !== -1 ? 'g/km' : unit;
        unit =
            fieldName.toLowerCase().indexOf('consumptionfrom') !== -1 ||
            fieldName.toLowerCase().indexOf('consumptionto') !== -1
                ? 'l/100 km'
                : unit;
        unit =
            fieldName.toLowerCase().indexOf('electricconsumptionfrom') !== -1 ||
            fieldName.toLowerCase().indexOf('electricconsumptionto') !== -1
                ? 'kWh'
                : unit;

        return unit;
    },
    showCarTypeVanTypeSelectedValueInHeader() {
        let carTypeValue = $('#advance_search input[name="carType[]"]:checked')
            .map(function () {
                return $(this).next('label').text() !== Translations.any ? $(this).next('label').text() : '';
            })
            .get();

        let vanTypeValue = $('#advance_search input[name="vanType[]"]:checked')
            .map(function () {
                return $(this).next('label').text() !== Translations.any ? $(this).next('label').text() : '';
            })
            .get();

        let displayValue = '';
        let totalSelected = 0;
        if (carTypeValue.length > 0) {
            displayValue = carTypeValue;
            totalSelected = carTypeValue.length;
        }

        if (vanTypeValue.length > 0) {
            displayValue = vanTypeValue;
            totalSelected += vanTypeValue.length;
        }

        return totalSelected > 1 ? Translations.advanced_search.multiple : displayValue;
    },
    showAccessoriesSelectedValueInHeader(object) {
        let selectedAccessorySectionId = object.closest('#advance_search .mobileFieldSection').attr('id');
        let value = $(`#advance_search #${selectedAccessorySectionId} input[name="accessories[]"]:checked`)
            .map(function () {
                return $(this).next('label').text() !== Translations.any ? $(this).next('label').text() : '';
            })
            .get();

        return value.length > 1 ? Translations.advanced_search.multiple : value;
    },
    showKilometerSelectedValueInHeader() {
        return $('#advance_search #undriven').is(':checked')
            ? Translations.advanced_search.undriven_only
            : advanceSearchFieldHeaderCommon.getValueForRangeField(
                  'kilometersFrom',
                  'kilometersTo',
                  true,
                  Translations.km
              );
    },
    showSelectedValueInFieldOnLoad() {
        setTimeout(() => {
            $('#advance_search')
                .find('input,select')
                .not(function () {
                    return advanceSearchFieldHeader.excludedFieldsInDisplay.some(
                        (input) => $(this).attr('name') && $(this).attr('name').startsWith(input)
                    );
                })
                .each(function () {
                    if ($(this).attr('name') === undefined) {
                        return;
                    }
                    advanceSearchFieldHeader.showSelectedValueInFieldHeader($(this));
                });
        }, 100);
    },
};
